export enum CdfSelectType {
  None = 'None',
  SingleSelect = 'SingleSelect',
  MultiSelect = 'MultiSelect',
  Boolean = 'Boolean',
  TextNumeric = 'TextNumeric',
  HierarchyBySelection = 'HierarchyBySelection',
  HierarchyByEntry = 'HierarchyByEntry'
}
